import React, { useEffect, useState } from 'react';
import './RegistrationForm.css';
import { toast } from 'react-toastify';
import API_URLS from '../summaryapi/apiUrls';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { RingLoader } from 'react-spinners'; // Import the spinner
import serviceProviderImage from '../assets/images/serviceprovider1.png'; // Correct the import
import * as XLSX from 'xlsx'; // Importing for Excel download
import { saveAs } from 'file-saver'; // For saving CSV files
import { FaPen } from 'react-icons/fa'; // Import the FaPen edit icon
import { FiSearch } from 'react-icons/fi'; // Search icon
import { jsPDF } from 'jspdf';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa'; // Importing icons
const RegistrationForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        mobile_number: '',
        address: '',
        password: '',
        category_id: '',
        is_available: false,
        is_active: false,
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [serviceProviders, setServiceProviders] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editProviderId, setEditProviderId] = useState(null);
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [passwordVisibilityState, setPasswordVisibilityState] = useState({});
    const [addressError, setAddressError] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const toggleProviderPasswordVisibility = (providerId) => {
      setPasswordVisibilityState((prevState) => ({
        ...prevState,
        [providerId]: !prevState[providerId],
      }));
    };

    const handleChangePincode = (event) => {
      const value = event.target.value;
      
      // Update pincode value in the state
      setFormData({ ...formData, pincode: value });
  
      // Clear the error message when user starts typing
      if (errorMessage) {
          setErrorMessage('');
      }
  
      // If the pincode is exactly 6 digits and valid, clear error message
      if (value.length === 6 && /^\d{6}$/.test(value)) {
          setErrorMessage(''); // Clear error if valid
      } else if (value.length === 6) {
          setErrorMessage('Pincode must be a 6-digit number'); // Show error if it's not numeric
      } else {
          setErrorMessage(''); // Clear error if length is less than 6
      }
  };
  

    // Function to handle pincode validation when input loses focus
    const handleBlurPincode = () => {
      const value = formData.pincode || ''; // Default to empty string if undefined or null
  
      if (value.length === 6 && /^\d{6}$/.test(value)) {
          setErrorMessage(''); // Clear the error if the pincode is valid
      } else if (value.length === 6) {
          setErrorMessage('Pincode must be a 6-digit number'); // Show error if length is 6 but not numeric
      } else {
          setErrorMessage('Pincode must be 6 digits'); // Show error if the length is not 6
      }
  };
  


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1); // Reset to the first page on search input
    };

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const fetchCategories = async () => {
      try {
          const response = await fetch(API_URLS.getAllServiceCategories.url);
          if (!response.ok) throw new Error('Failed to fetch categories');
          const result = await response.json();
          if (result.success) {
              setCategories(result.data);
          } else {
              toast.error('Error: ' + result.message);
          }
      } catch (error) {
          console.error('Error fetching categories:', error);
          toast.error('An error occurred while fetching categories.');
      }
  };

  
  const fetchServiceProviders = async () => {
    try {
        // Fetch the service providers data from the API
        const response = await fetch(API_URLS.getServiceProvidersAdmin.url);

        if (!response.ok) throw new Error('Failed to fetch service providers');

        const result = await response.json();

        // Check if the response is valid and the status is true
        if (result && result.status) {
            // Process the fetched data and map to the required structure
            const processedData = result.data.map((provider) => ({
                provider_id: provider.provider_id,
                name: provider.name,
                email: provider.email,
                mobile_number: provider.mobile_number,
                address: provider.address,
                password: provider.password, // Consider not storing/displaying passwords
                is_available: provider.is_available === "1" ? "Yes" : "No",
                is_active: provider.is_active === "1" ? "Yes" : "No",
                created_date: provider.created_date,
                category_name: provider.category_name,
                category_id: provider.category_id
            }));

            // Sort the processed data by created_date in descending order
            const sortedData = processedData.sort((a, b) => {
                // Ensure created_date is in valid date format (e.g., "YYYY-MM-DD")
                const dateA = new Date(a.created_date);
                const dateB = new Date(b.created_date);

                // Handle invalid date formats gracefully
                if (isNaN(dateA) || isNaN(dateB)) {
                    console.warn('Invalid date format found:', a.created_date, b.created_date);
                    return 0; // Maintain the original order if the date is invalid
                }

                return dateB - dateA; // Sort in descending order
            });

            // Update the state with sorted data
            setServiceProviders(sortedData);
        } else {
            const errorMessage = result && result.message ? result.message : 'Unknown error';
            toast.error('Error: ' + errorMessage);
        }
    } catch (error) {
        console.error('Error fetching service providers:', error);
        toast.error('An error occurred while fetching service providers.');
    } finally {
        setLoading(false);
    }
};

    useEffect(() => {

        fetchCategories();
        fetchServiceProviders();
    }, []);

    const [touchedFields, setTouchedFields] = useState({
        mobile_number: false,
        email: false,
    });

    const handleBlur = (e) => {
        const { name } = e.target;
        setTouchedFields((prev) => ({
            ...prev,
            [name]: true, // Mark field as touched
        }));
    };

    const [isHovered, setIsHovered] = useState(false); // Track hover state
  
    const handleAddNew = () => {
        setFormData({
            name: '',
            email: '',
            mobile_number: '',
            address: '',
            password: '',
            category_id: '',
            is_available: false,
            is_active: false,
        });
        setIsEditing(false); // We're in "registering" mode, not "editing"
    };
    const handleEdit = (provider) => {
      const pincodeRegex = /\d{6}$/;
      const extractedPincode = provider.address.match(pincodeRegex) ? provider.address.match(pincodeRegex)[0] : '';
  
        setFormData({
          
            name: provider.name,
            email: provider.email,
            mobile_number: provider.mobile_number,
            address: provider.address,
            pincode: extractedPincode, // Set extracted pincode
            password: provider.password, // You may choose to keep the password empty when editing
            category_id: provider.category_id, // Set the selected category id
            is_available: provider.is_available === "Yes",
            is_active: provider.is_active === "Yes",
        });
        setEditProviderId(provider.provider_id);
        setIsEditing(true); // Set the form to edit mode
    };
    
    
    const handleChangeAddress = (e) => {
      const { name, value } = e.target;
    
      // Update the form data
      setFormData({
        ...formData,
        [name]: value,
      });
    
      // Validate the address field
      if (name === "address") {
        validateAddress(value);
      }
    };
    const validateAddress = (address) => {
      let error = "";
    
      // Check if address is provided
      if (!address.trim()) {
        error = "Address is required.";
      }
      // Optional: Check if address length is at least 5 characters
      else if (address.length < 5) {
        error = "Address should be at least 5 characters long.";
      }
      // Optional: Check for maximum length
      else if (address.length > 100) {
        error = "Address should not exceed 100 characters.";
      }
    
      setAddressError(error);  // Set the error message
    };
  const isLengthValid = (mobile_number) => {
      return mobile_number.length === 10;
  };
  
  const isStartsWithValid = (mobile_number) => {
      return /^[6789]/.test(mobile_number);
  };
  
  
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    // Real-time validation for email
    const isEmailValid = (email) => {
        return emailPattern.test(email);
    };
    const handleSubmit = async (e) => {
      e.preventDefault();
      
      const { name, email, mobile_number, address, password, category_id, pincode } = formData;
  
      // Validate required fields
      if (!name || !email || !mobile_number || !address || !category_id) {
          toast.error('Please fill in all required fields');
          return;
      }
  
      // Check if pincode is provided and modify address accordingly
      let fullAddress = address;
  
      // If we are editing and pincode is provided, append/replace the pincode in the address
      if (pincode) {
          // Check if the address already contains a pincode (6 digits at the end of the address)
          const addressHasPincode = /\d{6}$/.test(fullAddress);
          
          if (addressHasPincode) {
              // Replace the existing pincode in the address if there's already a pincode
              fullAddress = fullAddress.replace(/\d{6}$/, pincode);
          } else {
              // If no pincode is found, append the new pincode
              fullAddress = `${fullAddress}, ${pincode}`;
          }
      }
  
      // Prepare request data with the updated full address
      const requestData = {
          name,
          email,
          mobile_number,
          address: fullAddress, // Use the full address with updated pincode
          password,
          category_id,
          is_available: formData.is_available ? '1' : '0',
          is_active: formData.is_active ? '1' : '0',
      };
  
      // If editing, include the provider_id (editProviderId) in the request data
      if (isEditing) {
          requestData.provider_id = editProviderId; // Add the provider_id for updating
      }
  
      try {
          let response;
          const requestPayload = JSON.stringify(requestData);  // Stringify the request data
  
          if (isEditing) {
              // Update existing provider using stringified request data, including provider_id
              response = await fetch(`${API_URLS.updateProviderAdmin.url}/${editProviderId}`, {
                  method: API_URLS.updateProviderAdmin.method,
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: requestPayload, // Send stringified data directly
              });
          } else {
              // Add new provider using stringified request data
              response = await fetch(API_URLS.addServiceProvider.url, {
                  method: API_URLS.addServiceProvider.method,
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: requestPayload, // Send stringified data directly
              });
          }
  
          // Check if the response is successful
          if (!response.ok) throw new Error('Network response was not ok');
  
          const result = await response.json();
          if (result.success) {
              const successMessage = isEditing ? 'Service provider updated successfully' : 'Service provider added successfully';
              toast.success(successMessage);
  
              // Prepare the new provider object with provider_id
              const newProvider = {
                  ...requestData,
                  provider_id: editProviderId, // Ensure provider_id is included
                  is_available: formData.is_available ? 'Yes' : 'No',
                  is_active: formData.is_active ? 'Yes' : 'No',
                  created_date: new Date().toISOString().split('T')[0],
                  category_name: categories.find(cat => cat.category_id === category_id)?.category_name || 'Unknown',
              };
  
              // Update the service providers list
              setServiceProviders((prev) => {
                  const updatedProviders = isEditing
                      ? prev.map(provider => provider.provider_id === editProviderId ? newProvider : provider)
                      : [...prev, newProvider];
                  localStorage.setItem('serviceProviders', JSON.stringify(updatedProviders)); // Update local storage
                  return updatedProviders;
              });
  
              // Reset the form and fetch the updated list of providers
              resetForm();
              fetchServiceProviders();
          } else {
              console.error('Error saving provider:', result);
              toast.error('Error: ' + result.message);
          }
      } catch (error) {
          console.error('Error during submission:', error);
          toast.error('An error occurred. Please try again.');
      }
  };
  
  
  
  

      

    const resetForm = () => {
        setFormData({
            name: '',
            email: '',
            mobile_number: '',
            address: '',
            password: '',
            pincode:'',
            category_id: '',
            is_available: false,
            is_active: false,
        });
        setIsEditing(false);
        setEditProviderId(null);
    };

    // Pagination logic
    const indexOfLastProvider = currentPage * itemsPerPage;
    const indexOfFirstProvider = indexOfLastProvider - itemsPerPage;
    const filteredProviders = serviceProviders.filter(provider => 
        provider.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    const currentProviders = filteredProviders.slice(indexOfFirstProvider, indexOfLastProvider);
    const pageCount = Math.ceil(filteredProviders.length / itemsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pageCount) {
            setCurrentPage(newPage);
        }
    };

    const handleDownloadPDF = () => {
      // Create a new jsPDF instance
      const doc = new jsPDF();
  
      // Set font
      doc.setFont('Arial', 'normal');
  
      // Set title
      doc.text('Service Providers', 14, 16);
  
      // Define table headers
      const headers = ['Name', 'Email', 'Mobile Number', 'Address', 'Category', 'Availability', 'Status', 'Created Date'];
  
      // Map the filtered providers data into a table-friendly format
      const rows = filteredProviders.map((provider) => [
          provider.name,
          provider.email,
          provider.mobile_number,
          provider.address,
          provider.category_name,
          provider.is_available ? 'Available' : 'Not Available',
          provider.is_active ? 'Active' : 'Inactive',
          provider.created_date,
      ]);
  
      // Add table to the PDF (you can adjust the position and size as needed)
      doc.autoTable({
          head: [headers],
          body: rows,
          startY: 30, // Adjust where the table starts
      });
  
      // Save the generated PDF with the name 'service_providers.pdf'
      doc.save('service_providers.pdf');
  };
    // Export to Excel
    const handleDownloadExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filteredProviders);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Service Providers');
        XLSX.writeFile(wb, 'service_providers.xlsx');
    };


    const isCategorySelected = formData.category_id !== '';

    return (
        <div>
        <div className="registration-wrapper">
            <div className="image-container">
                <img src={serviceProviderImage} alt="Service Provider" className="top-right-image" />
            </div>
            <div className="form-box">

                <form onSubmit={handleSubmit}>
                <h3 style={{color: '#8A2BE2'}}>
  {isEditing ? 'Edit Service Provider' : 'Service Provider Registration'}
</h3>



                    <div className="form-container">
                        
                        <div className="form-row">
                            <div className="form-holder">


                       <label htmlFor="category_id">Category</label>

<select
  className="form-control"
  id="category_id"
  name="category_id"
  value={formData.category_id}
  onChange={handleChange}
  required
>
  <option value="" disabled>Select Category</option>
  {categories.length > 0 ? (
    categories.map((category) => (
      <option key={category.category_id} value={category.category_id}>
        {category.category_name}
      </option>
    ))
  ) : (
    <option value="" disabled>No Categories Available</option>
  )}
</select>

                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-holder">
                                <label htmlFor="name">Full Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    placeholder="Enter Full Name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    disabled={!isCategorySelected}
                                    required={isCategorySelected}
                                />
                            </div>
                            <div className="form-holder">
    <label htmlFor="mobile_number">Mobile Number</label>
    <input
        type="text"
        className="form-control"
        id="mobile_number"
        name="mobile_number"
        placeholder="Enter Mobile Number"
        value={formData.mobile_number}
        onChange={handleChange}
        onBlur={handleBlur} // Trigger when the field loses focus
        disabled={!isCategorySelected}
        required={isCategorySelected}
        style={{
            borderColor:
                touchedFields.mobile_number && !isLengthValid(formData.mobile_number)
                    ? 'red'
                    : '',
        }}
    />
    {touchedFields.mobile_number && formData.mobile_number.length > 0 && (
        <>
            {!isLengthValid(formData.mobile_number) && (
                <p style={{ color: 'red', fontSize: '14px' }}>
                    Mobile number must be exactly 10 digits.
                </p>
            )}
            {!isStartsWithValid(formData.mobile_number) && (
                <p style={{ color: 'red', fontSize: '14px' }}>
                    Mobile number must start with 6, 7, 8, or 9.
                </p>
            )}
        </>
    )}
</div>

            <div className="form-holder">
                <label htmlFor="email">Email</label>
                <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Enter Email"
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur} // Trigger when the field loses focus
                    disabled={!isCategorySelected}
                    required={isCategorySelected}
                    style={{
                        borderColor:
                            touchedFields.email && !isEmailValid(formData.email)
                                ? 'red'
                                : '',
                    }}
                />
                {touchedFields.email && !isEmailValid(formData.email) && formData.email.length > 0 && (
                    <p style={{ color: 'red',fontSize:'14px' }}>Please enter a valid email address.</p>
                )}
            </div>







                            <div className="form-holder">
                                <label htmlFor="password">Password</label>
                                <div className="password-input">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className="form-control"
                                        id="password"
                                        name="password"
                                        placeholder="Enter Password"
                                        value={formData.password}
                                        onChange={handleChange}
                                        required={!isEditing} // Password is required only if not editing
                                        disabled={!isCategorySelected}
                                    />
                                    <button type="button" onClick={togglePasswordVisibility} className="toggle-password">
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </button>
                                </div>
                            </div>   



                            <div className="form-holder">
    <label htmlFor="address">Address</label>
    <input
        type="text"
        className="form-control"
        id="address"
        name="address"
        placeholder="Enter Address"
        value={formData.address}
        onChange={handleChangeAddress}
        disabled={!isCategorySelected}
        required={isCategorySelected}
        minLength={5}  // Optional: minimum length for address
        maxLength={100} // Optional: maximum length for address
    />
    {addressError && <div className="error text-danger" style={{color: 'red'}}>{addressError}</div>}
</div>

<div className="form-holder">
    <label htmlFor="pincode">Pincode</label>
    <input
        type="text"
        className={`form-control ${errorMessage ? 'input-error' : ''}`} // Apply the error class if there's an error
        id="pincode"
        name="pincode"
        placeholder="Enter Pincode"
        value={formData.pincode}
        onChange={handleChangePincode}
        onBlur={handleBlurPincode}  // Trigger validation when input loses focus
        disabled={!isCategorySelected}
        required={isCategorySelected}
        maxLength={6}
        pattern="\d{6}"
      />
      {errorMessage && <span className="error-message" style={{color:'red'}}>{errorMessage}</span>}  {/* Error message */}
</div>


                        </div>

                        <div className="form-row">
                            <div className="form-holder">
                                <label htmlFor="is_available">Available</label>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        id="is_available"
                                        name="is_available"
                                        checked={formData.is_available}
                                        onChange={handleChange}
                                        disabled={!isCategorySelected}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            <div className="form-holder">
                                <label htmlFor="is_active">Active</label>
                                <label className="switch">
                                    <input
                                        type="checkbox"
                                        id="is_active"
                                        name="is_active"
                                        checked={formData.is_active}
                                        onChange={handleChange}
                                        disabled={!isCategorySelected}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            <div className="flex justify-end w-full">
  {isEditing && (
    <button
      style={{ backgroundColor: 'green', marginTop: '20px' }}
      onClick={handleAddNew}
      className="registerbutton flex items-center gap-2"
    >
      <span       style={{ fontSize:'14px' }}>+</span> Add New Provider
    </button>
  )}
</div>

              </div>

                        <div>
                            <button type="submit" className='registerbutton' disabled={!isCategorySelected}>
                                <span>{isEditing ? 'Update' : 'Register'}</span>
                            </button>
                        </div>
                    </div>
                </form></div>
    <div style={{ width: '100%', padding: '20px', boxSizing: 'border-box' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
      <input
        type="text"
        placeholder="Search By Name.."
        value={searchTerm}
        onChange={handleSearchChange}
        onMouseEnter={() => setIsHovered(true)} // Set hover to true on mouse enter
        onMouseLeave={() => setIsHovered(false)} // Set hover to false on mouse leave
        style={{
          padding: '8px',
          borderRadius: '4px',
          border: isHovered ? '3px solid lightblue' : '1px solid lightblue', // Apply border on hover
          minWidth: '200px',
          marginRight: '8px', // Space between input and icon
          outline: 'none', // Remove default outline on focus
          transition: 'border 0.3s ease', // Smooth border transition
        }}
      />
      <FiSearch style={{ fontSize: '20px', color: '#888' }} /> {/* Search Icon */}
    </div>


      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-start' }}>
        <button
          onClick={handleDownloadPDF}
          style={{
            width:'150px',
            backgroundColor: 'red',
            height:'40px',
            color: 'white',
            textAlign: 'center',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
        }}
        >
           <span style={{ fontSize: '15px' }}> Download </span> <FaFilePdf style={{ fontSize: '15px' }} /> 
        </button>
        <button
          onClick={handleDownloadExcel}
          style={{
            width:'150px',
            backgroundColor: 'green',
            height:'40px',
            color: 'white',
            textAlign: 'center',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            marginLeft:'10px'
        }}
        >
      Download   <FaFileExcel style={{ fontSize: '15px' }} /> 
        </button>
      </div>   </div>
      {/* Table */}
      <table className="service-provider-table" style={{ width: '100%', borderCollapse: 'collapse' }}>      
      <thead>
  <tr>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Name</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Email</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Mobile</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Address</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Category</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Available</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Active</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Password</th>
    <th style={{ backgroundColor: 'blueviolet', color: 'white' }}>Actions</th>
  </tr>
</thead>

<tbody>
  {loading ? (
    <tr>
      <td colSpan="8" className="loading-cell" style={{ textAlign: 'center' }}>
        <RingLoader size={60} color="#3498db" />
      </td>
    </tr>
  ) : currentProviders.length > 0 ? (
    currentProviders
      .sort((a, b) => b.provider_id - a.provider_id) // Sort by provider_id in descending order
      .map((provider) => (
        <tr key={provider.provider_id}>
          <td>{provider.name}</td>
          <td>{provider.email}</td>
          <td>{provider.mobile_number}</td>
          <td>{provider.address}</td>
          <td>{provider.category_name}</td>
          <td>{provider.is_available}</td>
          <td>{provider.is_active}</td>
          <td>
            {passwordVisibilityState[provider.provider_id] ? provider.password : '*****'}
            <span
              onClick={() => toggleProviderPasswordVisibility(provider.provider_id)}
              style={{
                fontSize: '20px',
                cursor: 'pointer',
                marginLeft: '10px',
              }}
            >
              {passwordVisibilityState[provider.provider_id] ? <FaEyeSlash /> : <FaEye />}
            </span>
          </td>
          <td>
            <button
              className="edit-btn"
              onClick={() => handleEdit(provider)}
              style={{
                backgroundColor: '#3498db',
                color: 'white',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              <FaPen />
            </button>
          </td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="8" style={{ textAlign: 'center' }}>
        No service providers found
      </td>
    </tr>
  )}
</tbody>

</table>
      {/* Footer - Pagination and Download Buttons */}
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '15px' }}>
  <div>
    {/* Pagination Count */}
  <strong> <span>
      Showing {indexOfFirstProvider + 1} to {indexOfLastProvider} of {filteredProviders.length} entries
    </span></strong> 
  </div>

  {/* Center-aligned page count */}
  <div style={{ display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'center' }}>
    {/* Page count */}
    <span style={{ margin: '0 10px' }}>
      Page {currentPage} of {pageCount}
    </span>
  </div>

  <div style={{ display: 'flex', alignItems: 'center' }}>
  {/* Pagination Buttons */}
  <button
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
    style={{
      padding: '8px 12px',
      margin: '0 5px',
      backgroundColor: currentPage === 1 ? 'rgba(255, 0, 0, 0.5)' : '#e74c3c', // Red with opacity for disabled
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
      opacity: currentPage === 1 ? 0.5 : 1, // Reduced opacity for disabled state
    }}
  >
    Prev
  </button>
  <button
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === pageCount}
    style={{
      padding: '8px 12px',
      margin: '0 5px',
      backgroundColor: currentPage === pageCount ? 'rgba(39, 174, 96, 0.5)' : '#27ae60', // Green with opacity for disabled
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: currentPage === pageCount ? 'not-allowed' : 'pointer',
      opacity: currentPage === pageCount ? 0.5 : 1, // Reduced opacity for disabled state
    }}
  >
    Next
  </button>
</div>

</div>

    </div>
        </div>            </div>
    );
};

export default RegistrationForm;
